/** PAC-24667: column selectors for nested Bag → Shipment → Commodity print blocks. */
export const bagColumns = [
  { key: 'bagExt', label: 'Bag', defaultPrintWidth: 80, isSelected: true },
  {
    key: 'bagWeight',
    label: 'Weight (lb)',
    defaultPrintWidth: 60,
    isSelected: true,
  },
];

export const shipmentColumns = [
  {
    key: 'shipmentExt',
    label: 'Shipment',
    defaultPrintWidth: 100,
    isSelected: true,
  },
  { key: 'origin', label: 'Origin', defaultPrintWidth: 80, isSelected: true },
  {
    key: 'destination',
    label: 'Destination',
    defaultPrintWidth: 80,
    isSelected: true,
  },
  {
    key: 'shipmentWeight',
    label: 'Weight (lb)',
    defaultPrintWidth: 60,
    isSelected: true,
  },
  {
    key: 'shipperInfo',
    label: 'Shipper Information',
    defaultPrintWidth: 220,
    isSelected: true,
  },
  {
    key: 'consigneeInfo',
    label: 'Consignee Information',
    defaultPrintWidth: 220,
    isSelected: true,
  },
];

export const commodityColumns = [
  { key: 'hsCode', label: 'HS Code', defaultPrintWidth: 140, isSelected: true },
  {
    key: 'commodityValue',
    label: 'Commodity Value',
    defaultPrintWidth: 140,
    isSelected: true,
  },
  {
    key: 'commodityDescription',
    label: 'Commodity Description',
    defaultPrintWidth: 200,
    isSelected: true,
  },
];
